import client from "./client";

const authAPI = {
  login: (data) => {
    // {
    //   "identifier": "hdnham02@gmail.com",
    //   "password": "12345678"
    // }
    return client.post('/auth/local', data);
  },

  signup: (data) => {
    // {
    //   "username": "hdnham3",
    //   "email": "hdnham03@vnmap.inut.vn",
    //   "password": "VNMap12345@@"
    // }
    return client.post('/auth/local/register', data);
  },

  getMe: () => {
    return client.get('/users/me');
  },

  changePassword: (data) => {
    return client.post('/auth/change-password', data);
  },

  updateInfo: (data) => {
    return client.put('/edit-acc-info', {data});
  },

  deleteFactor: () => {
    return client.delete('/2fa/factor');
  },

  createNewFactorID: () => {
    return client.get('/2fa/factor');
  },

  verifyFactor: (otp, factorId, secret) => {
    return client.post('/2fa/factor', {
      otp,
      factor_id: factorId,
      secret,
    })
  }
}

export default authAPI;